// ANT Modules
import { Table as ANTtable } from "antd";

// Utils
import getIcon from "utils/getIcon";

// Hooks
import { useAppDispatch } from "app/hooks/hooks";

// Redux
import { updateCurrentGroup } from "redux/userList/userSlice";

export type VectorProps = {
	onClick?: (e: any) => void;
};

const UpVector = ({ onClick }: VectorProps): JSX.Element => {
	return (
		<span onClick={onClick} className="cursor-pointer">
			{getIcon({ icon: "upVector" })}
		</span>
	);
};
const DownVector = ({ onClick }: VectorProps): JSX.Element => {
	return (
		<span onClick={onClick} className="cursor-pointer">
			{getIcon({ icon: "downVector" })}
		</span>
	);
};

export type CollapsibleTableProps = {
	handleExpandRows?: (v: string) => void;
	voucherTypeHandler?: () => void;
	voucherDownloadHandler?: () => void;
	generateCols?: () => void;
	generateData?: (voucherTypeHandler?: () => void, voucherDownloadHandler?: () => void, groupItem?: Array<any>) => void;
	expandedRowElement?: (record: any) => JSX.Element;
	popOverClose?: (recordInfo: any) => void;
	rowClassName?: string;
	showHeader?: boolean;
	groupItem?: Array<any>;
	keyIndex: number | string;
	currentExpandedGroup?: string;
	defaultExpandedGroupKey?: string;
};

const CollapsibleTable = ({
	expandedRowElement,
	rowClassName,
	showHeader = true,
	groupItem,
	currentExpandedGroup,
	defaultExpandedGroupKey,
	popOverClose,
	voucherTypeHandler,
	voucherDownloadHandler,
	generateCols,
	generateData,
	handleExpandRows
}: CollapsibleTableProps): JSX.Element => {
	const dispatch = useAppDispatch();
	const col = generateCols?.();
	const data = generateData?.(voucherTypeHandler, voucherDownloadHandler, groupItem);
	// This method will store the selected group in redux
	const updateSelectedGroup = () => {
		if (groupItem && groupItem[0]?.group_code) {
			dispatch(updateCurrentGroup(groupItem[0]?.group_code));
		}
		if (groupItem && groupItem[0]?.perm_code) {
			dispatch(updateCurrentGroup(groupItem[0]?.perm_code));
		}
		if (groupItem && groupItem[0]?.voucher_group_code) {
			dispatch(updateCurrentGroup(groupItem[0]?.voucher_group_desc));
		}
	};

	const updateGroup = (record: any) => {
		const uniqueId = `${record?.summary_item?.voucher_group_code}${record?.summary_item?.year_month}`;
		if (record) {
			dispatch(updateCurrentGroup(uniqueId));
		}
	};

	const getDefaultKey = defaultExpandedGroupKey ? [defaultExpandedGroupKey] : [];
	const getCurrentKey = currentExpandedGroup === "" ? [] : undefined;

	return (
		<div className="collapsible_table">
			<ANTtable
				dataSource={data ?? []}
				columns={col ?? []}
				expandable={{
					onExpand: (expanded, record: { key: string }) => {
						if (expanded && handleExpandRows) {
							handleExpandRows(record?.key);
						} else if (!expanded && handleExpandRows) {
							handleExpandRows("");
						}
					},
					defaultExpandedRowKeys: getDefaultKey,
					expandedRowKeys: currentExpandedGroup ? [currentExpandedGroup] : getCurrentKey,
					expandedRowRender: (record) => expandedRowElement?.(record),
					expandIcon: ({ expanded, onExpand, record }) =>
						expanded ? (
							<UpVector
								onClick={(e) => {
									onExpand(record, e);
									popOverClose?.(record);
								}}
							/>
						) : (
							<DownVector
								onClick={(e) => {
									onExpand(record, e);
									groupItem ? updateSelectedGroup() : updateGroup(record);
								}}
							/>
						)
				}}
				pagination={false}
				rowKey={(record) => record?.key}
				rowClassName={rowClassName}
				scroll={{ x: true }}
				showHeader={showHeader}
			/>
		</div>
	);
};

export default CollapsibleTable;
